module.exports = __webpack_public_path__ + "static/media/slide-1-image.25eaa711.svg";